import React, { useCallback } from "react";
import LessonDataVideo from "./LessonDataVideo";
import LessonDataBox from "./LessonDataBox";
import LessonDataAudioList from "./LessonDataAudioList";
import LessonDataListOrder from "./LessonDataListOrder";
import LessonDataSelect from "./LessonDataSelect";
import LessonDataDiscoverWord from "./LessonDataDiscoverWord";
import LessonDataDiscoverSentence from "./LessonDataDiscoverSentence";
import LessonDataUnion from "./LessonDataUnion";
import LessonDataUnionWithBox from "./LessonDataUnionWithBox";

const LessonData = ({ seed = undefined, freeze = false, onChange = () => {}, sort = false }) => {
  const lessons = {
    LESSON_VIDEO: LessonDataVideo,
    LESSON_BOX: LessonDataBox,
    LESSON_AUDIO_LIST: LessonDataAudioList,
    LESSON_LIST_ORDER: LessonDataListOrder,
    LESSON_SELECT: LessonDataSelect,
    LESSON_DISCOVER_WORD: LessonDataDiscoverWord,
    LESSON_DISCOVER_SENTENCE: LessonDataDiscoverSentence,
    LESSON_UNION: LessonDataUnion,
    LESSON_UNION_WITH_BOX: LessonDataUnionWithBox,
  };

  const type = getType(seed);
  const Lesson = lessons[type];

  const memoizedOnChange = useCallback(
    (state) => onChange({ ...state, data: { [type]: state.data } }),
    [onChange, type]
  );

  return (
    <>
      {Lesson && (
        <Lesson
          seed={seed?.[type]}
          onChange={memoizedOnChange}
          freeze={freeze}
        />
      )}
    </>
  );
};

const getType = (data) => Object.keys(data || {})[0];

export default LessonData;
